import { IDeviceProperties } from "./DeviceProperties";

export default interface IDeviceFetchViewData {
    codeId: string;
    name: string;
    serialNumber: string;
    properties: IDeviceProperties[];
}

export class DeviceFetchViewData implements IDeviceFetchViewData {
    codeId: string;
    name: string;
    serialNumber: string;
    properties: IDeviceProperties[];

    constructor(codeId: string, name: string, serialNumber: string, properties: IDeviceProperties[]) {
        this.codeId = codeId;
        this.name = name;
        this.serialNumber = serialNumber;
        this.properties = properties;
    }
}

const defaultDeviceFetchViewData = new DeviceFetchViewData("", "", "", []);
export { defaultDeviceFetchViewData }